// (C) Copyright 2015 Moodle Pty Ltd.
//
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
//     http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.

import { Injectable } from '@angular/core';

import { CoreContentLinksHandlerBase } from '@features/contentlinks/classes/base-handler';
import { CoreContentLinksAction } from '@features/contentlinks/services/contentlinks-delegate';
import { CoreNavigator } from '@services/navigator';
import { makeSingleton } from '@singletons';
import { WP_CATALOGUE_MAIN_MENU_HOME_PAGE_NAME } from '../../constants';
import { WorkplaceCatalogue } from '../catalogue';

/**
 * Handler to treat links to course catalogue.
 */
@Injectable({ providedIn: 'root' })
export class WorkplaceCatalogueLinkHandlerService extends CoreContentLinksHandlerBase {

    name = 'WorkplaceCatalogueLinkHandler';
    pattern = /(\/course)|(\/course\/index\.php)|(\/course\/search\.php)/;
    priority = 300;

    /**
     * @inheritdoc
     */
    async isEnabled(siteId?: string): Promise<boolean> {
        return await WorkplaceCatalogue.isGetCataloguePageAvailable(siteId);
    }

    /**
     * @inheritdoc
     */
    getActions(siteIds: string[], url: string, params: Record<string, string>): CoreContentLinksAction[] {
        const matches = url.match(this.pattern);

        if (!matches || matches.length < 1) {
            return [];
        }

        const path = params.categoryid || params.q
            ? `/main/home/${WP_CATALOGUE_MAIN_MENU_HOME_PAGE_NAME}/search`
            : `/main/home/${WP_CATALOGUE_MAIN_MENU_HOME_PAGE_NAME}`;

        params = { query: params.q, categoryId: params.categoryid };

        return [{
            action: async (siteId: string): Promise<void> => {
                CoreNavigator.navigateToSitePath(path, { params, preferCurrentTab: false, siteId });
            },
        }];
    }

}

export const WorkplaceCatalogueLinkHandler = makeSingleton(WorkplaceCatalogueLinkHandlerService);
